export const formatKey = (key: string) => key.replace('[]', '');
export const isArrayKey = (key: string) => key.includes('[]');
export const getKeyParts = (key: string) => formatKey(key).split('.');
